/**
 * Formata um número de telefone no formato `(00) 00000-0000`.
 *
 * @param telefone Telefone com 11 digitos para ser formatado
 * @returns Número formatado, retorna o próprio parâmetro
 *   `telefone` se for inválido
 */
export function formatarTelefone(telefone: string) {
  const telefoneAux = telefone.replace(/\D/g, '');

  if (telefoneAux.length === 11) {
    return telefoneAux.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
  } else {
    return telefone;
  }
}
